

export default function install ( mod ) 
{
    mod.directive('expandMenu', function () {

        return {
            restrict: 'A',
            link: function ($scope, $element) {
                // Obtém o menu
                var menu = $($element[0])

                // Adciona o evento click nos links
                menu.find('a').on('click', function( event ) {

                    // Seleciona o menu do contexto
                    var li = $(event.target).parent()

                    if (li.is('.in')) {

                        li.removeClass('in')

                        $('ul:first', li).slideUp(100)

                    } else {

                        li.addClass('in')

                        $('ul:first', li).slideDown(100)
                    }

                })
                
                // Essa trigger é temporaria, deve ser removida
                // na versão futura desta aplicação
                .trigger('click')
            }
        }

    })
}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/plugins/menu.plugin.js
// module id = 325
// module chunks = 1